import { render, staticRenderFns } from "./OnboardingAwaitingNoVideo.vue?vue&type=template&id=3f8e127c&"
import script from "./OnboardingAwaitingNoVideo.vue?vue&type=script&lang=js&"
export * from "./OnboardingAwaitingNoVideo.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAwaitingNoVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports